// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__23eRQ","fileDisabled":"File_fileDisabled__1RAH5"};